import { useTranslation } from 'react-i18next';

export function formatBufferTimeValue(bufferTime: number): string {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  if (bufferTime === 0) {
    return `${t('bookings.eventLimits.none')}`;
  }
  if (bufferTime >= 60) {
    const hours = bufferTime / 60;
    const hourText = hours === 1 ? t('bookings.eventLimits.hour') : t('bookings.eventLimits.hours');
    if (language === 'si') {
      return `${hourText} ${hours} ${t('bookings.eventLimits.beforeAndAfter')}`;
    }
    return `${hours} ${hourText} ${t('bookings.eventLimits.beforeAndAfter')}`;
  }
  if (language === 'si') {
    return `${t('bookings.eventLimits.minutes')} ${bufferTime} ${t(
      'bookings.eventLimits.beforeAndAfter'
    )}`;
  }
  return `${bufferTime} ${t('bookings.eventLimits.minutes')} ${t(
    'bookings.eventLimits.beforeAndAfter'
  )}`;
}

export function formatMinimumNoticeTimeValue(minimumNoticeTime: number): string {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  if (minimumNoticeTime >= 60) {
    const hours = minimumNoticeTime / 60;
    const hourText = hours === 1 ? t('common.hour') : t('bookings.eventLimits.hours');
    if (language === 'si') {
      return `${hourText} ${hours}`;
    }
    return `${hours} ${hourText}`;
  }
  if (language === 'si') {
    return `${t('common.minutes')} ${minimumNoticeTime}`;
  }
  return `${minimumNoticeTime} ${t('common.minutes')}`;
}

export function formatDayLimitValue(dayLimit: number): string {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  if (dayLimit === 0) {
    return `${t('bookings.eventLimits.noLimit')}`;
  }
  const eventText =
    dayLimit === 1 ? t('bookings.eventLimits.event') : t('bookings.eventLimits.events');
  if (language === 'si') {
    return `${eventText} ${dayLimit}`;
  }
  return `${dayLimit} ${eventText}`;
}

// utility function to create options for dropdown
export function createOptions(
  values: number[],
  formatValue: (_value: number) => string
): { value: string; label: string }[] {
  return values.map((value) => ({
    value: value.toString(),
    label: formatValue(value),
  }));
}
